<div *ngIf="libraryName ==='' || libraryName === ':libraryName'">
  <p>Please select a library from the list.</p>
</div>

<div *ngIf="libraryName !=='' && libraryName !== ':libraryName'">
  <h3>Editing table {{ libraryName }} <small>{{ mode }}</small></h3>

  <div *ngIf="isLoading" class="loading-spinner">
    <img src="assets\ajax-loader.gif" alt="Loading...">
  </div>

  <div *ngIf="!isLoading">
    <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
    <div *ngIf="!errorMessage" style="justify-content: space-between; display: flex;">
      <div style="display: flex; gap: 10px;">
        <select id="tabSelect" (change)="onTabChange($event)">
          <option value="" selected>All Tabs</option>
          <option *ngFor="let tabName of allowedTabNames" [value]="tabName">{{ tabName }}</option>
        </select>
        <div *ngIf="orderingEnabled" style="display: flex; gap: 10px;">
          <label for="advancedOrderingToggle" style="margin: auto; vertical-align: middle;">Advanced Ordering</label>
          <input type="checkbox" style="height: 20px; width: 20px; vertical-align: middle; margin: auto;" [(ngModel)]="advancedOrdering">
        </div> 
      </div>

      <div style="display: flex; flex-direction: column; gap: 2px; margin-left: auto; align-items: flex-start;">
        <label for="unitSetSelect" style="margin: 0; font-size: 12px;">Unit Set</label>
        <select id="unitSetSelect" (change)="onUnitSetChange($event)">
          <option value="" [selected]="selectedUnitSet === ''">Default</option>
          <option *ngFor="let unitSet of unitSets" [value]="unitSet" [selected]="unitSet === selectedUnitSet">{{ unitSet }}</option>
        </select>
      </div>

      <div style="display: flex; gap: 10px;">
        <button (click)="addRow(selectedTabName)" [disabled]="selectedTabName === '' && hasMultipleTabNames">Add New Entry</button>
        <button (click)="processClipboardData()" [disabled]="selectedTabName === '' && hasMultipleTabNames">Paste Rows From Clipboard</button>
      </div>
    </div>
    <p *ngIf="selectedTabName === '' && hasMultipleTabNames" class="alert-message">Select a tab first to add a new entry<span *ngIf="advancedOrdering"> or sort the rows</span></p>

    <ng-container *ngIf="!errorMessage" style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
      <input style="width: 100%; margin-top: 5px;" type="text" placeholder="Search..." (input)="onSearch($event)">
      
      <div style="display: flex; margin-top: 10px; justify-content: space-between">
        <div style="display: flex; gap: 10px;">
          <button (click)="undo()" [disabled]="(library$ | async)?.past?.length === 0">Undo</button>
          <button (click)="redo()" [disabled]="(library$ | async)?.future?.length === 0">Redo</button>
        </div>

        <div style="display: flex; gap: 10px;">
          <ng-container *ngIf="advancedOrdering">
            <select [(ngModel)]="orderingColumn"  [disabled]="selectedTabName === '' && hasMultipleTabNames">
                <option *ngFor="let column of columns" [value]="column.columnName" [selected]="column.columnName === orderingColumn">{{ column.columnName }}{{ column.unit ? ' (' + column.unit + ')' : '' }}</option>
            </select>
            <select [(ngModel)]="orderingDirection" [disabled]="(selectedTabName === '' && hasMultipleTabNames)">
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </select>
            <button (click)="sortRows()" [disabled]="(selectedTabName === '' && hasMultipleTabNames)">Sort Tab</button>
          </ng-container>            
        </div>
      </div>
      
      <div class="table-container">
        <table npTable>
          <thead>
            <tr>
              <th *ngIf="advancedOrdering" style="margin: 0 auto; text-align: center;">order</th>
              <th style="margin: 0 auto; text-align: center;">delete</th>
              <ng-container *ngFor="let column of columns">                
                <th *ngIf="column.columnName === 'syshelp'" style="margin: 0 auto; text-align: center;">help</th>
                <th *ngIf="column.columnName === 'sysreferencedata'" style="margin: 0 auto; text-align: center;">filter</th>
                <th *ngIf="column.columnName !== 'syshelp' && column.columnName !== 'sysreferencedata'" style="margin: 0 auto; text-align: center;">{{ column.columnName }}{{ column.unit ? ' (' + column.unit + ')' : '' }}</th>
              </ng-container>
            </tr>
          </thead>
          <tbody>
              <tr *ngFor="let row of displayedRows" class="table-row">
                <td *ngIf="advancedOrdering" [ngStyle]="{'background-color':getRowColor(row.id)}">
                  <input
                    type="number"
                    style="margin: 0 auto; width: 70px;"
                    [value]="row.order"
                    (keydown.enter)="onOrderChange(row.id, $event)"
                    (blur)="onOrderChange(row.id, $event)"
                  />
                </td>
                <td [ngStyle]="{'background-color':getRowColor(row.id)}">
                  <input
                    type="checkbox"
                    [checked]="selectedRowsIdsToDelete.has(row.id)"
                    (change)="onRowSelectionChange(row.id, $event)"
                    style="margin: 0 auto; display: block; width: 20px; height: 20px;"
                  />
                </td>
                <ng-container *ngFor="let column of columns">
                    <td 
                    [ngStyle]="{'background-color': getRowColor(row.id)}">
                    <input 
                      type="{{column.type === 'double' ? 'number' : 'text'}}"
                      style="margin: 0 auto; display: block;"
                      [ngClass]="'input' + column.columnName"
                      [ngModel]="row[column.columnName] || ''" 
                      (ngModelChange)="onInputChange(row.id, column.columnName, $event)"
                      (blur)="onInputBlur(row.id, column.columnName)"
                      (focus)="onInputFocus(row.id)"
                      [disabled]="column.columnName === 'sysreferencedata' && this.enableColumnForEdit() === false"
                    />                  
                    </td>
                </ng-container>              
              </tr>
          </tbody>
        </table>        
        <div *ngIf="displayedRows.length == 0 && !selectedTabName && !searchTerm" class="error-message">This Table is currently empty.</div>
        <div *ngIf="displayedRows.length == 0 && (selectedTabName || searchTerm)" class="error-message">There are no rows for the current filters.</div>
      </div>  
    </ng-container>

    <div *ngIf="!errorMessage" style="display: flex; justify-content: space-between; margin-top: 10px;">
      <div style="display: flex; gap: 10px;">        
        <button (click)="submitLibrary()" [disabled]="((library$ | async)?.past?.length ?? 0) === 0">Save Changes</button>
        <p *ngIf="((library$ | async)?.past?.length ?? 0) >= 1" class="alert-message">You Have Unsaved Changes</p>
      </div>
      
      <div>
        <button (click)="previousPage()">Previous</button>
        <span style="margin: 10px;">Page </span>
        <select [(ngModel)]="currentPage" (change)="onPageChange($event)">
          <option *ngFor="let page of [].constructor(totalPages); let i = index" [value]="i">{{ i + 1 }}</option>
        </select>
        <span style="margin: 10px;">of {{ totalPages }}</span>
        <button (click)="nextPage()">Next</button>
      </div>
    </div>
    
  </div>  
</div>